import React from "react";
import tradingSettingFunctional from "./index.function";
import ViewItems from "../../components/ViewItems";
import Text from "../../components/Text";
import { fontSizes } from "../../constants/constants";
import ViewReverse from "../../components/ViewReverse";
import { rowReverseStyle } from "../../utils/styles";
import CustomDropdown from "../../components/CustomDropdown";
import CustomCheckbox from "../../components/CustomCheckbox";
import Button from "../../components/Button";

const TradingSettings = () => {
  const {
    isArabic,
    TextWeight,
    getContentKey,
    handleTradingSettings,
    tradingSettings,
    tradingSettingsDropdown,
    resetLoading,
    resetSettings,
    saveSettings,
    settingLoading,
  } = tradingSettingFunctional();

  return (
    <ViewItems>
      <Text
        text={getContentKey("heading")}
        weight={TextWeight.regular}
        size={fontSizes.h24}
        color={"text-dark-blue"}
      />

      <ViewReverse
        className={`w-full items-center gap-[10%] mt-4 flex-col md:${rowReverseStyle(
          isArabic
        )}`}
      >
        <CustomDropdown
          label={getContentKey("order_side_label")}
          options={tradingSettingsDropdown?.orderSides}
          selectedValue={tradingSettings.orderSide}
          onSelect={(val) => handleTradingSettings("orderSide", val)}
        />
        <CustomDropdown
          label={getContentKey("good_label")}
          options={tradingSettingsDropdown?.goodTills}
          selectedValue={tradingSettings.goodTill}
          onSelect={(val) => handleTradingSettings("goodTill", val)}
          className={"mt-4 md:mt-0"}
        />
      </ViewReverse>

      <ViewReverse
        className={`w-full items-center gap-[10%] mt-4 flex-col md:${rowReverseStyle(
          isArabic
        )}`}
      >
        <CustomDropdown
          label={getContentKey("buy_mode")}
          options={tradingSettingsDropdown?.orderTypeInBuyModes}
          selectedValue={tradingSettings.buyMode}
          onSelect={(val) => handleTradingSettings("buyMode", val)}
        />
        <CustomDropdown
          label={getContentKey("fill_term_label")}
          options={tradingSettingsDropdown?.fillTerms}
          selectedValue={tradingSettings.fillTerm}
          onSelect={(val) => handleTradingSettings("fillTerm", val)}
          className={"mt-4 md:mt-0"}
        />
      </ViewReverse>

      <ViewReverse
        className={`w-full items-center gap-[10%] mt-4 flex-col md:${rowReverseStyle(
          isArabic
        )}`}
      >
        <CustomDropdown
          label={getContentKey("sell_mode")}
          options={tradingSettingsDropdown?.orderTypeInSellModes}
          selectedValue={tradingSettings.sellMode}
          onSelect={(val) => handleTradingSettings("sellMode", val)}
        />
        <CustomDropdown
          label={getContentKey("portfolio_label")}
          options={tradingSettingsDropdown?.clientPortfolios}
          selectedValue={tradingSettings.portfolio}
          onSelect={(val) => handleTradingSettings("portfolio", val)}
          className={"mt-4 md:mt-0"}
        />
      </ViewReverse>

      <ViewReverse
        className={`w-full items-start gap-[10%] mt-4 flex-col-reverse md:${rowReverseStyle(
          isArabic
        )}`}
      >
        <div className="w-full md:w-1/2 flex flex-col gap-4 mt-4 md:mt-0">
          <CustomCheckbox
            isChecked={tradingSettings.isPricingServer}
            label={getContentKey("pricing_server")}
            onClick={() =>
              handleTradingSettings(
                "isPricingServer",
                !tradingSettings.isPricingServer
              )
            }
          />
          <CustomCheckbox
            isChecked={tradingSettings.isPlacement}
            label={getContentKey("placement")}
            onClick={() =>
              handleTradingSettings("isPlacement", !tradingSettings.isPlacement)
            }
          />
          <CustomCheckbox
            isChecked={tradingSettings.isBitOffer}
            label={getContentKey("price_warning")}
            onClick={() =>
              handleTradingSettings("isBitOffer", !tradingSettings.isBitOffer)
            }
          />
        </div>
        <div className="w-full md:w-1/2">
          <CustomDropdown
            label={getContentKey("account_label")}
            options={tradingSettingsDropdown?.cashAccounts}
            selectedValue={tradingSettings.cashAccount}
            onSelect={(val) => handleTradingSettings("cashAccount", val)}
          />
        </div>
      </ViewReverse>

      <ViewReverse className="items-center w-full justify-end gap-2 mt-8 mb-6">
        <Button
          text={getContentKey("reset_btn")}
          color={"text-dark-grey"}
          bgColor="bg-white"
          className={
            "border border-dark-grey text-center w-32 border-opacity-50"
          }
          loading={resetLoading}
          onClick={resetSettings}
          loaderColor={"border-t-gray-600"}
        />
        <Button
          text={getContentKey("save_btn")}
          bgColor="bg-primary"
          className={"text-center w-32 border border-orange"}
          loading={settingLoading}
          onClick={saveSettings}
        />
        <Button
          text={getContentKey("cancel_btn")}
          color={"text-dark-grey"}
          bgColor="bg-white"
          className={
            "border border-dark-grey text-center w-32 border-opacity-50"
          }
        />
      </ViewReverse>
    </ViewItems>
  );
};

export default TradingSettings;
